import React from "react";
import { Link, graphql } from "gatsby";
import { Div } from "atomize";

import SEO from "../components/seo";
import Layout from "../components/common/layout";
import Header from "../components/common/Header";

import Footer from "../components/common/Footer";
import CaseStudy from "../components/casestudy/CaseStudy";

import CtaFooter from "../components/common/CtaFooter";
import CaseStudyCard from "../components/common/CaseStudyCard";
import WebsiteContainer from "../components/common/WebsiteContainer";
import CustomContainer from "../components/common/CustomContainer";
import SubscribeNewsletter from "../components/common/SubscribeNewsletter";
import BlogCtaFooter from "../components/common/BlogCtaFooter";
import { useEffect } from "react";
import { openLinks } from "../utilities/helpers";

const CaseStudyPost = ({ data }) => {
  const caseStudy = data.contentfulCaseStudy;

  const subscribeContent = JSON.parse(data.contentfulJson.json.json)
    .subscribeContent;

  const blogCtaFooter = JSON.parse(data.contentfulJson.json.json).blogCtaFooter;

  useEffect(() => {
    openLinks();
  });

  return (
    <Layout>
      <SEO
        seo={data.contentfulCaseStudy.seo}
        url={`https://trend.io/case-study/${caseStudy.slug}`}
      />
      <Header headerFixed={true} data={{ contentfulJson: data.headerJson }} />
      <WebsiteContainer>
        <SubscribeNewsletter
          subscribeContent={subscribeContent}
          form={data.contentfulGlobalConfig.blogForm.blogForm}
        />
      </WebsiteContainer>
      <CaseStudy caseStudy={caseStudy} />
      <WebsiteContainer>
        <BlogCtaFooter blogCtaFooter={blogCtaFooter} />
      </WebsiteContainer>
      <Footer
        contentfulFooter={data.contentfulFooter}
        contentfulGlobalConfig={data.contentfulGlobalConfig}
      />
    </Layout>
  );
};

export default CaseStudyPost;

export const query = graphql`
  query($slug: String!) {
    contentfulFooter(contentful_id: { eq: "5noUnCCOBDl8Is2Ppw2Nty" }) {
      solutions {
        label
        link
        isExternal
      }
      menu {
        label
        link
        isExternal
      }
      links {
        label
        link
        isExternal
      }
      instagramLink
      logoLink
    }

    contentfulGlobalConfig {
      footerForm {
        footerForm
      }

      blogForm {
        blogForm
      }
    }

    headerJson: contentfulJson(
      contentful_id: { eq: "2NCeKxLHd9JagUBAEsXDMo" }
    ) {
      json {
        json
      }
    }

    contentfulJson(contentful_id: { eq: "738JKhyXxk0qhMd167aN2h" }) {
      json {
        json
      }
      seo {
        ...SeoFragment
      }
    }

    contentfulCaseStudy(slug: { eq: $slug }) {
      id
      title
      slug
      color
      companyLogo {
        file {
          url
        }
        description
      }
      companyName
      userImage {
        file {
          url
        }
        description
      }
      content {
        json
      }
      ctaLabel
      ctaLink
      ctaTitle

      seo {
        ...SeoFragment
      }
    }
  }
`;
